export function getWhiteCardRoute(path) {
    return { path }
}
